import { render, staticRenderFns } from "./NumberSpinner.vue?vue&type=template&id=1993af74&scoped=true"
import script from "./NumberSpinner.vue?vue&type=script&lang=js"
export * from "./NumberSpinner.vue?vue&type=script&lang=js"
import style0 from "./NumberSpinner.vue?vue&type=style&index=0&id=1993af74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993af74",
  null
  
)

export default component.exports